module.exports = __webpack_public_path__ + "static/img/sororas-1.2f50623.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/sororas-1.jpg
// module id = NDqn
// module chunks = 1